import { useEffect, useState } from "react";
import { Error, Edit, Delete } from "@mui/icons-material";
import { Card, Tooltip, Zoom, IconButton } from "@mui/material";
import DashboardLayout from "../../../Layouts/Layoutcontainers";
import BTButton from "../../../components/BTButton";
import BTBox from "../../../components/BTBox";
import EnhancedTable from "../../../components/BTTable";
import authService from "../../../services/auth-service";
import Addprice from "./Addprice";
import ConfirmBox from "../../../components/ConfirmBox";
import { useLoading, useNotification } from "../../../context";
import { service_price_type } from "../../../dropdownData/index";
import {
  get_price_lists,
  get_sizes,
  get_parties,
  get_services,
} from "../../../store/functions";
import { useSelector } from "react-redux";
const PriceList = () => {
  const priceList = useSelector((state) => state?.lab?.priceList);
  const sizes = useSelector((state) => state?.lab?.sizes);
  const parties = useSelector((state) => state?.lab?.parties);
  const services = useSelector((state) => state?.lab?.services);
  const [open, setOpen] = useState(null);
  const [isDelete, setDelete] = useState(null);
  const { showLoading, hideLoading } = useLoading();
  const { addNotification } = useNotification();

  const ExpandedComponent = ({ row }) => {
    const priceListData = priceList?.data?.filter(
      ({ p_id, pl_deleted }) => p_id === row?.p_id && !pl_deleted
    );

    const columns = [
      {
        id: "id",
        name: "ID",
        selector: (row, index) => index + 1,
        width: "0.1rem",
        numeric: false,
        sortable: true,
      },
      {
        id: "ser_id",
        name: "Service",
        selector: (row) =>
          services?.data?.find(({ ser_id }) => ser_id === row?.ser_id)
            ?.ser_name,
        sortable: true,
        numeric: false,
        width: "100px",
      },
      {
        id: "ser_price_type",
        name: "Service Price Type",
        selector: (row) =>
          service_price_type?.find(({ value }) => value === row?.ser_price_type)
            ?.label,
        width: "100px",
      },
      {
        id: "size_id",
        name: "Size",
        selector: (row) => {
          if (row?.ser_price_type === 1) {
            return "Fixed";
          } else {
            const size = sizes?.data?.find(
              ({ size_id }) => size_id === row?.size_id
            );

            return `${Number(size?.size_from).toFixed(2)} - ${Number(
              size?.size_to
            ).toFixed(2)}`;
          }
        },
        width: "100px",
      },
      {
        id: "ser_rate",
        name: "Service Rate",
        numeric: false,
        selector: (row) => row?.ser_rate,
        sortable: false,
        width: "100px",
      },
      {
        id: "pl_desc",
        name: "Description",
        numeric: false,
        selector: (row) => row?.pl_desc,
        sortable: false,
        width: "100px",
      },
      {
        id: "actions",
        name: "Actions",
        selector: (row) => (
          <Tooltip title={"Delete"}>
            <Delete
              color="error"
              sx={{ cursor: "pointer", fontSize: "18px" }}
              onClick={() => {
                setDelete(row);
              }}
            />
          </Tooltip>
        ),
        width: "80px",
        bodyCellStyle: {
          padding: "0px ",
        },
        center: true,
      },
    ];
    return (
      <BTBox sx={{ p: 2 }}>
        <EnhancedTable
          tableHeader={true}
          rows={priceListData}
          columns={columns}
          title="Price List"
          defaultSort="carbs"
          pagination={true}
        />
      </BTBox>
    );
  };

  const CardHeader = () => {
    return (
      <Card sx={{ mb: 1 }}>
        <BTBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          pt={2}
          pb={2}
          px={3}
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}
        >
          <BTButton
            variant="gradient"
            size="small"
            color="dark"
            onClick={async () => {
              showLoading();
              await new Promise((resolve) => setTimeout(resolve, 1000));
              hideLoading();
              setOpen({
                p_id: 0,
                items: priceList?.data?.filter(({ p_id }) => p_id === 0),
              });
            }}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            default price list
          </BTButton>
        </BTBox>
      </Card>
    );
  };
  const Actions = ({ row }) => {
    return (
      <BTBox display="flex" flexDirection={"row"} gap={1}>
        <Tooltip title="Edit">
          <Edit
            color="warning"
            sx={{ cursor: "pointer", fontSize: "18px" }}
            onClick={async () => {
              const priceListData = priceList?.data?.filter(
                ({ p_id, pl_deleted }) => p_id === row?.p_id && !pl_deleted
              );
              showLoading();
              await new Promise((resolve) => setTimeout(resolve, 1000));
              hideLoading();
              setOpen({ p_id: row?.p_id, items: priceListData });
            }}
          />
        </Tooltip>
      </BTBox>
    );
  };
  const getPriceList = async () => {
    showLoading();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const response = await get_price_lists();
    if (!response?.status) {
      addNotification({
        message: response?.message?.message || "Something went wrong",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    }
    hideLoading();
  };
  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "0.1rem",
    },
    {
      id: "p_id",
      name: "Party",
      selector: (row) => row?.p_name,
      sortable: true,
      numeric: false,
    },
    {
      id: "actions",
      name: "Actions",
      cell: (row) => <Actions row={row} />,
      width: "80px",
      bodyCellStyle: {
        padding: "0px",
      },
    },
  ];

  useEffect(() => {
    !sizes?.is_fetch && get_sizes();
    !priceList?.is_fetch && getPriceList();
    !parties?.is_fetch && get_parties();
    !services?.is_fetch && get_services();
  }, []);

  return (
    <DashboardLayout>
      <CardHeader />
      <EnhancedTable
        tableHeader={true}
        rows={parties?.data}
        columns={columns}
        title="Price List"
        defaultSort="carbs"
        pagination={true}
        expandRow={true}
        expandComponent={<ExpandedComponent />}
      />
      {Boolean(open) && (
        <Addprice
          open={open}
          setOpen={setOpen}
          parties={parties?.data}
          sizes={sizes?.data}
          services={services?.data}
          priceList={priceList?.data}
        />
      )}
      {Boolean(isDelete) && (
        <ConfirmBox
          row={isDelete}
          setDelete={setDelete}
          id="pl_id"
          name="priceList"
          service={authService?.delete_pricelist}
        />
      )}
    </DashboardLayout>
  );
};
export default PriceList;
